<script>
	const Vue = require('vue');
	const _ = require('underscore');
	const model = require('model/model');
	const page = require('page');
	const vocabData = require('data/vocab-scope-and-sequence.json');
	const productService = require('services/productService');
	const Q = require('q');
	const metadata = require('core/metadata');
	const metadataUtils = require('metadata-utils');
	const utilities = require('utilities');
	const scrollManager = require('ui/core/scrollManager');
	const { fireEvent, events } = require('utilities/analyticsUtilities');
	const classUtilities = require('utilities/classUtilities');
	const { assetUrl } = require('utilities/urlUtilities');

	const SCOPE_SEQUENCE_VIEW = events.SCOPE_SEQUENCE_VIEW;
	const SCOPE_SEQUENCE_CLICK = events.SCOPE_SEQUENCE_CLICK;
	const SCOPE_SEQUENCE_FILTER = events.SCOPE_SEQUENCE_FILTER;
	const SCOPE_SEQUENCE_ASSIGN_OPEN = events.SCOPE_SEQUENCE_ASSIGN_OPEN;

	const ssData = metadata.scopeAndSequence;
	const setData = {};
	let keys = [];

	if (ssData && ssData.length) {
		// Static Data
		setData.vocabulary = vocabData;

		ssData.forEach(s => {
			let key = s.meta ? s.meta.key : null;
			setData[key] = s;
			keys.push(key);
		});

		keys = Object.keys(setData);
		keys.sort();
	}

	module.exports = {
		components: {
			'load-mask': require('components/load-mask.vue').default,
			'grade-selector': require('components/grade-selector.vue').default,
			'article-image': require('components/article-image.vue').default,
			'info-icon': require('components/svg/info-icon.vue').default,
			'assignment-wizard': require('components/assignment-wizard.vue').default
		},
		modelData: ['activeClasses', 'selectedGrades', 'selectedSet', 'expanded', 'userContext'],
		data() {
			return {
				loadingClasses: false,
				loading: {},
				activeProducts: {},
				gradesInSet: {},
				assignProducts: null,
				subtitle: null,
				sets: setData,
				keys
			};
		},
		computed: {
			setId() {
				let id = 1101;
				let selectedSet = this.selectedSet;
				let sets = this.sets;

				if (selectedSet && sets[selectedSet] && sets[selectedSet].id) {
					id = sets[selectedSet].id;
				}

				return id;
			},
			setOptions() {
				let sets = this.sets;

				return Object.keys(sets)
					.sort()
					.map(s => {
						return {
							value: sets[s].meta.key,
							text: sets[s].meta.name.replace(/^\w/, c => c.toUpperCase())
						};
					});
			},
			activeMetadata() {
				let meta = {};
				let selectedSet = this.selectedSet;
				let sets = this.sets;

				if (selectedSet && sets[selectedSet] && sets[selectedSet].meta) {
					meta = sets[selectedSet].meta;
				}

				return meta;
			},
			products() {
				let selectedSet = this.selectedSet;
				let sets = this.sets;
				let data = sets[selectedSet].products;
				let gradesInSet = {};
				let productsByMonthGrade = data.reduce((acc, p) => {
					let grade = p.grade;
					let month = p.month;

					if (grade) {
						let node = metadata.allActiveNodesById['_' + grade];
						gradesInSet[grade] = node;
					}
					if (acc[month] && acc[month][grade]) {
						acc[month][grade].push(p);
					} else if (acc[month]) {
						acc[month][grade] = [p];
					} else {
						acc[month] = {
							[grade]: [p]
						};
					}
					return acc;
				}, {});

				this.gradesInSet = gradesInSet;
				return productsByMonthGrade;
			},
			sequencePanels() {
				let products = this.products;
				let meta = this.activeMetadata;
				let panels = Object.keys(products).reduce((acc, m) => {
					let monthProducts = products[m];
					if (monthProducts) {
						let title = meta.titles && meta.titles[m];
						let theme = meta.themes && meta.themes[m];
						let number = m;
						acc.push({
							title,
							number,
							theme,
							products: monthProducts
						});
					}
					return acc;
				}, []);
				return panels;
			},
			noClasses() {
				let activeClasses = this.activeClasses;
				return !activeClasses || activeClasses.length === 0;
			},
			gradeSelections: function () {
				let selectedGrades = this.selectedGrades || [];
				let gradesInSet = this.gradesInSet;

				let selections = metadata.gradeSelections.filter(g => {
					return gradesInSet[g.id];
				});
				return selections.map(g =>
					_.assign({}, g, {
						selected: _.contains(selectedGrades, g.id)
					})
				);
			},
			gradesFiltered() {
				return this.selectedGrades && this.selectedGrades.length !== 0;
			},
			gradeFilterLookup() {
				const selectedGrades = this.selectedGrades || [];
				return selectedGrades.reduce((lookup, g) => {
					lookup[g] = true;
					return lookup;
				}, {});
			},
			filterEventData() {
				let data = {};
				let selectedGrades = this.selectedGrades;
				let month = this.expanded;

				data.ssId = this.setId;

				if (selectedGrades && selectedGrades.length) {
					data.sg = [].concat(this.selectedGrades);
				}

				if (month) {
					data.m = month;
				}

				return data;
			},
			defaultOptions() {
				let options = {};
				let selectedSet = this.selectedSet;

				if (selectedSet === 'vocabulary') {
					options = {
						wordDetective: true,
						meaningMapper: true
					};
				}
				return options;
			},
			headerImgSrc() {
				return assetUrl('/assets/dist/images/scope-and-sequence-header.jpg');
			}
		},
		methods: {
			toggleExpand(event, month) {
				let alreadyExpanded = this.expanded === month;

				model.set('expanded', alreadyExpanded ? null : month);

				if (!alreadyExpanded) {
					fireEvent(
						SCOPE_SEQUENCE_CLICK,
						_.assign(this.filterEventData, {
							m: month
						})
					);

					this.loadForMonth(month);
				}

				if (event && event.currentTarget) {
					let target = event.currentTarget;
					setTimeout(() => {
						scrollManager(target, {
							priority: 2,
							duration: 500
						});
					}, 0);
				}
			},
			loadForMonth(month) {
				let products = this.products;
				let promises = [];
				let prms = Q();

				this.setLoading(month, true);

				if (products && products[month]) {
					Object.keys(products[month])
						.reduce((acc, grade) => {
							acc = acc.concat(products[month][grade]);
							return acc;
						}, [])
						.forEach(p => {
							if (!this.activeProducts[p.pid]) {
								let productPrms = productService.get(p.pid);
								promises.push(productPrms);
							}
						});
				}

				if (promises.length) {
					Q.all(promises).then(pdata => {
						this.activeProducts = pdata.reduce(
							(acc, product) => {
								acc[product.uuid] = product;
								return acc;
							},
							Object.assign({}, this.activeProducts)
						);
					});
				}
				prms.then(() => this.setLoading(month, false));
			},
			setLoading(month, isLoading) {
				this.loading = _.assign({}, this.loading, {
					[month]: isLoading
				});
			},
			getGradeName(id) {
				let key = '_' + id;
				let node = metadata.allActiveNodesById[key];
				let gradeName = '';
				if (node && node.name) {
					if (key === '_16') {
						gradeName = 'Kindergarten';
					} else {
						gradeName = metadataUtils.getOrdinal(node.name) + ' Grade';
					}
				}
				return gradeName;
			},
			launchAssignmentWizard(month, grade) {
				let products = this.products;
				let meta = this.activeMetadata;
				let ssId = this.setId;
				let subtitle = '';
				let assignProductIds = [];
				let filterEventData = this.filterEventData;

				if (products[month] && products[month][grade]) {
					assignProductIds = products[month][grade].map(p => {
						return {
							pid: p.pid,
							ssp: p.id
						};
					});
					subtitle = meta && meta.titles ? meta.titles[month] : '';
					subtitle += ' - ' + this.getGradeName(grade);
				}

				this.subtitle = subtitle;
				this.assignProducts = assignProductIds;
				fireEvent(
					SCOPE_SEQUENCE_ASSIGN_OPEN,
					_.assign(filterEventData, {
						ssId: ssId,
						m: month,
						g: grade
					})
				);
				utilities.openModal('#assignment-wizard', {
					eventData: {
						id: ssId,
						m: month,
						g: grade
					}
				});
			},
			onProductClick() {
				model.set('scopeSequenceLink', true);
			},
			loadClasses() {
				this.loadingClasses = true;
				let prms = classUtilities.loadActiveClasses();
				prms.finally(() => (this.loadingClasses = false));
				return prms;
			},
			createClass() {
				utilities.openModal('#modal-create-class');
				model.set('scopeSequenceLink', true);
			},
			onGradeClick(g) {
				let filterEventData = this.filterEventData;
				if (!this.selectedGrades) {
					model.set('selectedGrades', []);
				}

				if (_.contains(this.selectedGrades, g.id)) {
					model.set(
						'selectedGrades',
						this.selectedGrades.filter(i => i !== g.id)
					);
				} else {
					model.set('selectedGrades', this.selectedGrades.concat([g.id]));

					fireEvent(
						SCOPE_SEQUENCE_FILTER,
						_.assign(filterEventData, {
							sg: this.selectedGrades,
							g: g.id || undefined
						})
					);
				}
			},
			decodablesPresent(currentProducts) {
				const activeProducts = this.activeProducts;
				return this.setId === 1101 && currentProducts.some(p => activeProducts[p.pid] && activeProducts[p.pid].dteGroups);
			}
		},
		watch: {
			selectedSet(set, oldSet) {
				if (oldSet) {
					model.set('selectedGrades', []);
					this.toggleExpand();
					fireEvent(
						SCOPE_SEQUENCE_FILTER,
						_.assign(this.filterEventData, {
							set: set
						})
					);
				}
			}
		},
		mounted() {
			let filterEventData = this.filterEventData;
			fireEvent(SCOPE_SEQUENCE_VIEW, filterEventData);

			if (!this.userContext) {
				let hash = window.location.hash;
				let search = window.location.search;
				let pathname = window.location.pathname;
				page('/?url=' + encodeURIComponent(pathname + search + hash) + '#login');
			} else {
				if (!this.selectedSet && keys && keys.length) {
					model.set('selectedSet', keys[0]);
				}

				if (this.expanded) {
					this.loadForMonth(this.expanded);
					Vue.nextTick(() => {
						scrollManager($('div[data-panel-number="' + this.expanded + '"]', this.$el), {
							priority: 3,
							duration: 100
						});
					});
				}

				this.loadClasses();
				this.$subscribe('modal-closed', (modalId, options) => {
					if (modalId !== 'modal-create-class') {
						return;
					}
					this.loadClasses();
				});
			}
		}
	};
</script>
<style lang="scss">
	@import 'config/variables';
	@import 'config/colors';

	.scope-and-sequence {
		header.main-header {
			padding-top: 1rem;
			padding-bottom: 1rem;
		}

		.scope-sequence-info {
			display: flex;
			flex-wrap: wrap;
			align-items: center;

			.scope-sequence-info-copy {
				flex: 1;
				min-width: 20rem;
			}

			.scope-sequence-info-image img {
				height: 250px;
				margin: 0 1rem;
			}
		}

		.scope-and-sequence-sets {
			position: relative;
		}

		.sets-title {
			display: flex;
			align-items: center;

			h2 {
				flex: 1;
			}

			.validated-form {
				flex-basis: 15rem;
			}
		}

		.expandable-panel {
			position: relative;
			min-height: 5rem;

			button.expand-button {
				position: absolute;
				top: 1.5rem;
				right: 1rem;
				border-radius: 1rem;
				height: 2rem;
				width: 2rem;
				padding: 0;
			}

			.title {
				cursor: pointer;
				padding: 1.5rem 0;
				margin: 0;
				border-top: 1px solid $c-grey;
				font-size: 1.25rem;
			}

			.expandable-panel-body {
				display: none;

				.grade-month {
					display: flex;
					margin: 0.5rem 0 0.5rem 0;
					background-color: $c-blue-lighter;

					.grade-title {
						display: flex;
						flex-direction: column;
						padding: 0 1rem 3rem 1rem;
						font-size: 1.25rem;
						flex-basis: 10rem;

						.spacer {
							flex: 1;
							display: flex;
							align-items: center;
						}
					}

					.grade-month-products {
						display: flex;
						flex: 1;
						flex-wrap: wrap;
						padding: 0.5rem;

						.product-item {
							display: flex;
							flex: 0 0 50%;
							text-align: center;
							border-radius: 4px;
							padding: 0.5rem;
							min-width: 10rem;

							.product-meta {
								text-align: left;
								padding: 0.5rem;
								display: flex;
								flex-direction: column;
								justify-content: center;

								.week-title {
									color: $c-slate-dark;
								}
							}

							&:hover {
								cursor: pointer;
								background-color: $c-blue-highlight;
							}
						}
					}

					.grade-month-decodables-footer {
						flex: 0 0 100%;
						padding-left: 0.5rem;
					}
				}
			}

			&.expanded {
				.expandable-panel-body {
					display: block;
				}
			}
		}

		form.validated-form.filter-bar {
			display: flex;

			.set-filter {
				min-width: 12rem;

				select {
					margin-top: 0.5rem;
				}

				&:after {
					top: 2.5rem;
				}
			}

			label {
				font-weight: 700;
			}

			.grade-filter {
				flex-grow: 1;

				> label {
					display: inline-block;
				}

				.grade-selector {
					--item-selector-individual-width: 4rem;
				}
			}
		}
	}
</style>
<template>
	<div class="scope-and-sequence">
		<header class="main-header">
			<div class="wrapper">
				<h1 class="main-header-title">Article-A-Day Scope & Sequences</h1>
			</div>
		</header>
		<div class="main-content wrapper">
			<section v-if="selectedSet">
				<div class="scope-sequence-info">
					<div class="scope-sequence-info-copy">
						<p>
							Use our Article-A-Day Scope & Sequence tool below to quickly assign up to a full year of Article-A-Day!
							<strong
								>You can also now access kindergarten, first-grade, and second-grade <a href="/teacher-guide/decodable-texts.html">decodable texts</a> through
								our Scope & Sequence.</strong
							>
							Start Article-A-Day at the beginning of the year and begin the decodables in December for kindergarten and October for first and second grades.
						</p>
						<p>
							To make your planning simple, the Article-A-Day sets are grouped topically or to systematically build vocabulary. Both Scope & Sequences can be
							started at any point in the school year. Now it is even easier to achieve the best practice of doing Article-A-Day for at least 15 weeks a
							year!
						</p>
						<p>
							Before you get started,
							<a href="/teacher-guide/article-a-day-routine.html">review or learn the Article-A-Day routine</a>
							and
							<a href="/teacher-guide/aadss.html">see an overview of each Scope & Sequence.</a>
							Now choose a Scope & Sequence and click on a grade level below to start assigning!
						</p>
					</div>
					<div class="scope-sequence-info-image">
						<img :src="headerImgSrc" />
					</div>
				</div>
				<div class="scope-and-sequence-sets">
					<load-mask v-if="loadingClasses"></load-mask>
					<div
						class="no-classes text-bold butter-bar text-centered margin-bottom-medium"
						v-if="!loadingClasses && noClasses">
						To assign the Scope & Sequence digitally, you will need to create a class.
						<div class="margin-top-medium">
							<button
								class="button -large"
								@click="createClass">
								Create A Class
							</button>
						</div>
					</div>
					<form
						@submit.prevent
						class="filter-bar validated-form">
						<div class="set-filter select-wrapper input-wrapper">
							<label>Choose a set</label>
							<select
								v-model="selectedSet"
								class="touched">
								<option
									v-for="(set, idx) in setOptions"
									:key="set.value"
									:value="set.value">
									{{ set.text }}
								</option>
							</select>
						</div>
						<div class="grade-filter">
							<label id="scope-grade-selector-label">Select your grade(s) to assign</label>
							<button
								class="button -link"
								v-tooltip="
									'The Scope & Sequences start with sets at a lower grade level so that students can learn the Article-A-Day routine. Sets then gradually become more challenging as the year progresses.'
								">
								<info-icon></info-icon>
							</button>
							<grade-selector
								aria-labelledby="scope-grade-selector-label"
								:grades="gradeSelections"
								:on-grade-click="onGradeClick"
								prek-view>
							</grade-selector>
						</div>
					</form>
					<div class="sets-title">
						<h2>{{ sets[selectedSet].meta.name }} Scope & Sequence Set</h2>
					</div>
					<div
						v-for="panel in sequencePanels"
						:key="panel.number"
						:data-panel-number="panel.number"
						class="expandable-panel"
						:class="{
							expanded: expanded === panel.number,
							loading: loading[panel.number]
						}">
						<h3
							class="title"
							@click="toggleExpand($event, panel.number)">
							{{ panel.title }} {{ panel.theme ? ': ' + panel.theme : '' }}
						</h3>
						<button
							class="button expand-button"
							@click="toggleExpand($event, panel.number)"
							:aria-label="expanded === panel.number ? 'Collapse' : 'Expand'">
							<i
								class="fa-solid"
								:class="{
									'fa-chevron-down': expanded !== panel.number,
									'fa-chevron-up': expanded === panel.number
								}"
								aria-hidden="true"></i>
						</button>
						<div
							class="expandable-panel-body"
							v-if="expanded === panel.number">
							<load-mask v-if="loading[panel.number]"></load-mask>
							<template v-for="(grade, idx) in panel.products">
								<div
									v-if="!gradesFiltered || gradeFilterLookup[idx]"
									class="grade-month">
									<div class="grade-title">
										<div class="grade-title-text spacer">{{ getGradeName(idx) }}</div>
										<button
											@click="launchAssignmentWizard(panel.number, idx)"
											:disabled="noClasses"
											class="assign-button button -small">
											Assign
										</button>
										<div class="spacer"></div>
									</div>
									<div class="grade-month-products">
										<template v-for="product in grade">
											<a
												:href="`/article/${product.pid}`"
												class="product-item"
												@click="onProductClick">
												<article-image
													:image-url="activeProducts[product.pid] && activeProducts[product.pid].img"
													:alt-text="activeProducts[product.pid] && activeProducts[product.pid].imgAlt">
												</article-image>
												<div class="product-meta">
													<div class="product-title">{{ product.title }}</div>
													<div
														class="week-title"
														v-if="!product.at">
														Week {{ product.week }}: {{ product.theme }}
													</div>
													<div
														class="week-title"
														v-if="product.at === 'wd'">
														Week {{ product.week }} Focus Word Part: {{ product.theme }}<br />Word Detective Activity
													</div>
													<div
														class="week-title"
														v-if="product.at === 'mm'">
														Week {{ product.week }} Focus Word: {{ product.theme }}<br />Meaning Mapper Activity
													</div>
													<div
														v-if="setId === 1101 && activeProducts[product.pid] && activeProducts[product.pid].dteGroups"
														class="text-muted">
														Includes Decodables
													</div>
												</div>
											</a>
										</template>
										<div
											v-if="decodablesPresent(grade)"
											class="grade-month-decodables-footer">
											What are Decodables?
											<button
												class="button -link"
												v-tooltip="
													'ReadWorks nonfiction decodables help students practice their decoding while building background knowledge on the same topic as the week’s Article-A-Day set.'
												">
												<info-icon></info-icon>
											</button>
										</div>
									</div>
								</div>
							</template>
						</div>
					</div>
				</div>
			</section>
		</div>
		<assignment-wizard
			:product-ids="assignProducts"
			:subtitle="subtitle"
			:defaults="defaultOptions"></assignment-wizard>
	</div>
</template>
